<template>
    <v-main>
        <v-card flat class="px-2">            
            <v-container>
                <v-col cols="10" xl="6" offset="1" offset-xl="3">
                    <v-row class="pl-3">
                        <h2>Send complaint</h2>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="mailSend===true" class="primary mr-4 mt-2" small v-on:click="sendMail"><v-icon medium class="mr-2">{{ this.buttonIcon }}</v-icon>{{ this.buttonCaption }}</v-btn>
                    </v-row>
                    <v-divider class="mt-6 mb-2"></v-divider>    
                    <v-row dense>
                        <v-col cols="12">
                            <incident_header :col1="4" :col2="4" :isDense="true" :fontsize="'medium'" :incident="incident" @updateData="updateData"/>
                        </v-col>    
                    </v-row>
                    <v-row dense>
                        <v-col cols="12">
                            <incident_components :col1="4" :col2="4" :isDense="true" :amount="incident.claim_amount" :components="xcomponents"/>
                        </v-col>    
                    </v-row>                                
                    <v-row dense>
                        <v-col cols="10">
                            <select_hoct :huov_encrid="params[0]" :label="'Send e-mail to:'" :selected_hoct="hoct_sel" field="hoct_sel" :isClearable="true" :visibleChips="4" @updateData="updateData"/>    
                        </v-col>
                        <v-col cols="2">
                            <send_mail_info :huov_encrid="params[0]" :selected_contacts="hoct_sel" @updateData="updateData"/>
                        </v-col>
                    </v-row>   
                    <v-row class="mt-0">
                        <v-col cols="12">
                            <v-text-field dense label="Subject" v-model="incident.subject" clearable></v-text-field>
                        </v-col>
                    </v-row>                    
                    <v-row dense class="mt-0">
                        <v-col cols="12">
                            <v-textarea v-model="incident.description" rows="4" label="Mail text" class="mt-0"></v-textarea>
                        </v-col>
                    </v-row>   
                    <v-row dense>
                        <v-col cols="12">
                            <select_attachments :attachments="attachments" table="hokl" @updateData="updateData"/>
                            <!-- <v-btn v-on:click="testTimer()">test</v-btn>
                            <v-btn v-on:click="stopTimer()">stop test</v-btn> -->
                        </v-col>    
                    </v-row>                                
                </v-col>
            </v-container>
        </v-card>        
        <navBar title="Ares - Send mail" :home="true"/>
        <standard_dialog ref="std_dialog" /> 
        <please_wait ref="wait" :isPersistent="true" display_text="Sending..." :timerInterval="500"/>
    </v-main>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import select_attachments from '@/components/ui/selectors/select_attachments.vue'
import standard_dialog from '@/components/ui/standard_dialog.vue';
import please_wait from '@/components/pleaseWait.vue'

import select_hoct from '@/components/huov/ui/select_hoct.vue'
import incident_header from '@/components/huov/ui/hokl_hosm_mail_header.vue'
import incident_components from '@/components/huov/ui/hokl_hosm_mail_components.vue'
import send_mail_info from '@/components/huov/hokl/ui/send_mail_info.vue'

export default {
    props: ['param'],
	components: {
        select_hoct,
        incident_header,
        incident_components,
        select_attachments,
        navBar,
        send_mail_info,
        standard_dialog,
        please_wait
	},
	data() {
		return {
            hoct_sel: [],
            params: [],
            selected: [],
            incident: {},
            xcomponents: [],
            attachments: [],
            mailSend: false,
            mail_language: '',
            buttonCaption: 'Send mail',
            buttonIcon: 'mdi-email-fast-outline',
            date_received_iso: ''
		}
	},
    created() { // set up event bus listener here on created event or get data
        if (this.param != null) {
            this.params = this.param.split(":"); // 0 = huov, 1 = hokl
        }
    },    
    mounted() {
        this.getIncidentData();
    },
	methods: {
        getIncidentData() {
            this.$axios
                .post("ares/json/ares/huov/hokl/getIncidentData.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getComplaintData",
                    },
                    getComplaintData: {
                        hokl_encrid: this.params[1],
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {                        
                        this.incident=res.data.incident;
                        this.xcomponents=res.data.components;
                        this.attachments=res.data.attachments;
                    }
                });
        },        
        sendMail() {
            this.$refs.wait.open();
            this.incident.description = this.convertTextToHtml(this.incident.description);
            this.incident.mail_recepients = this.hoct_sel.toString();
            this.incident.mail_language = this.mail_language;
            if(this.date_received_iso !=='' && this.date_received_iso !==null){
                this.incident.date_received = this.$moment(this.date_received_iso).format('DD-MM-YYYY');
            }
            this.$axios
                .post("ares/json/ares/huov/hokl/sendHokl.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "sendHokl",
                    },
                    sendHokl: {
                        claim: this.incident,
                        attachments: this.selected,
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.$refs.wait.close();
                        this.$refs.std_dialog.open('error', 'Error', res.data.error.message);                               
                    } else {
                        this.mailSend=true;
                        this.buttonCaption='Mail sent';
                        this.buttonIcon='mdi-check-circle-outline';
                        this.$refs.wait.close();
                    }
                })
        },     
        testTimer(){
            this.$refs.wait.open();
        },
        stopTimer(){
            this.$refs.wait.close();
        },
        convertTextToHtml(text) {
            return text.replace(/\n/gi, '<br>'); // yes indeed, regular expression!!
        },           
        updateData(data){
            this[data.field] = data.value;
        },		
    }
}

</script>

<style scoped>
</style>